import React from 'react';
const accelerators = [{
  name: 'iSmart',
  description: 'AI for school management workflows'
}, {
  name: 'Easy Parle',
  description: 'Chatbot & voice agent for customer engagement'
}, {
  name: 'Talexy',
  description: 'Recruitment & talent intelligence'
}, {
  name: 'Voxtailor',
  description: 'AI translation & localization'
}, {
  name: 'Ezofis',
  description: 'Document and workflow automation'
}, {
  name: 'Relix',
  description: 'Social scheduling & engagement analytics'
}];
const industries = ['Technology', 'Pharma & Life Sciences', 'Manufacturing', 'Banking & Financial Services', 'Retail & eCommerce', 'Healthcare', 'Insurance', 'Telecommunications', 'Energy & Utilities', 'Public Sector', 'Education', 'Logistics', 'Travel & Hospitality', 'Recruitment', 'Digital'];
export function ExpertiseSection() {
  return <section id="expertise" className="py-24 bg-slate-50" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <h2 className="section-title" data-id="element-33">Our Accelerators & Industry Expertise</h2>
        <p className="section-subtitle" data-id="element-34">
          We combine ready-to-deploy solutions with deep domain knowledge to
          solve your unique challenges.
        </p>

        {/* Accelerators */}
        <div className="mt-16" data-id="element-35">
          <h3 className="text-2xl font-bold text-center text-slate-900" data-id="element-36">
            Accelerators (Ready-to-Deploy)
          </h3>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-37">
            {accelerators.map(accelerator => <div key={accelerator.name} className="card text-center" data-id="element-38">
                <h4 className="text-lg font-bold text-blue-600" data-id="element-39">
                  {accelerator.name}
                </h4>
                <p className="mt-1 text-slate-600" data-id="element-40">{accelerator.description}</p>
              </div>)}
          </div>
        </div>

        {/* Industries */}
        <div className="mt-20" data-id="element-41">
          <h3 className="text-2xl font-bold text-center text-slate-900" data-id="element-42">
            Industries We Serve
          </h3>
          <div className="mt-12 flex flex-wrap justify-center gap-3" data-id="element-43">
            {industries.map(industry => <span key={industry} className="bg-white text-slate-700 text-sm font-medium px-4 py-2 rounded-full shadow border border-slate-200" data-id="element-44">
                {industry}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}